import React from 'react';
import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

import type { IFilter } from '../types';

const REST_TYPES_PRESETS = [
  { id: 'ski', label: i18n.t('filters.region.mountain'), field: 'rest_type' },
  { id: 'beach', label: i18n.t('filters.region.sea'), field: 'rest_type' },
  {
    id: 'sightseeing',
    label: i18n.t('filters.region.culture'),
    field: 'rest_type',
  },
];

// TODO: presets, expand_label
const FilterRegions = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <MultichoiceFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    presets={REST_TYPES_PRESETS}
    Filter={FilterRegions}
    expandLabel={i18n.t('filters.region.show')}
    visibleItems={5}
  />
);

export default Object.assign(FilterRegions, {
  filterName: 'regions',
  filterLabel: i18n.t('filters.region.title'),
});
